<template>
  <v-container fluid class="trainings-hub d-flex flex-column">
        <HubTour v-if="showTour && !freeTrainingDialog && !showConversionDialog" 

        :has-workout-plan="!!workout" 
        :has-old-plans="oldWorkoutPlans.length > 0" 
        @complete="handleTourComplete" 
        @create-plan="goToCreatePlan" 
        @start-conversion="showConversionDialog = true" 
        @start-free-training="startFreeTraining" 
    />

    <PlanConverter   v-if="showConversionDialog" :value="showConversionDialog" @close="showConversionDialog = false" />

    <v-dialog v-model="showSuccessPopup" max-width="400" content-class="elevation-0" persistent>
      <v-card class="success-popup-card text-center pa-5">
        <v-icon size="120" color="green darken-1" class="success-icon mb-2">🎉</v-icon>
        <h4 class="font-weight-bold text-h5 white--text mt-4">Super!</h4>
        <p class="white--text mt-2 mb-6">Dein Plan wurde erfolgreich aktualisiert. Viel Spass beim nächsten Training! 💪</p>
        <v-btn color="primary" block large rounded @click="closeSuccessPopup">Verstanden</v-btn>
      </v-card>
    </v-dialog>
<transition name="slide-down">
    <div v-if="activeWorkoutExists" class="active-workout-banner" :style="`border: 2px solid ${activeSplitVisualization.color}`" @click="continueWorkout">
        <div class="glow-border"></div>
        <div class="shine-effect"></div>
        <div class="content">
                <v-img style="height: 45px; width: 45px; margin-right: 5px;" :src="activeSplitVisualization.img" contain></v-img>
            <div class="active-info" style="flex-grow:1;">
                <div class="title">{{ activeSplit.title }}</div>
                <div class="status">
                    <span>{{ activeWorkoutElapsedTime }}</span>
                    <div class="live-indicator"></div>
                </div>
            </div>
            <div style="width: 30px"></div>
             <v-btn icon small class="close-btn" @click.stop="promptCancelWorkout">
                <v-icon color="red">mdi-close</v-icon>
            </v-btn>
        </div>
    </div>
</transition>

    <div v-if="loading" class="mt-4">
      <h4 class="skeleton-text" style="width: 220px; height: 32px"></h4>
      <v-slide-group dark>
        <v-slide-item v-for="i in 3" :key="`skel-split-${i}`">
          <v-card class="ma-2 rounded-xl skeleton-loader" height="160" width="130"></v-card>
        </v-slide-item>
      </v-slide-group>
    </div>
    <v-row no-gutters class="mt-4" v-else-if="workout" id="tour-step-2-target">
      <v-col>
      
       <h4 class="font-weight-bold px-0 white--text d-flex align-center my-0" id="tour-step-2-headline">
  <v-btn x-large style="position: fixed; top: 10px; left: 10px; z-index: 5; " icon dark @click="$router.push('/')" color="white">
    <v-icon  color="white">mdi-chevron-left</v-icon>
  </v-btn>

  <v-progress-circular v-if="isRefreshing" style="position: fixed; top: 10px; right: 10px; z-index: 5; " indeterminate size="52" width="2" color="white" class="ml-3">
  </v-progress-circular>
  
  <v-menu  v-else-if="workout" offset-y left>
    <template v-slot:activator="{ on, attrs }">
      <v-btn x-large style="position: fixed; top: 10px; right: 10px; z-index: 5;" icon dark v-bind="attrs" v-on="on">
        <v-icon>mdi-cog-outline</v-icon>
      </v-btn>
    </template>
    <v-list dense dark class="menu-list-custom py-2">
        <v-list-item @click="showDownloadDialog = true">
        <v-list-item-icon class="mr-3">
          <v-icon>mdi-download-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-title>Split herunterladen</v-list-item-title>
      </v-list-item>
      <v-list-item @click="goToEditPlan">
        <v-list-item-icon class="mr-3">
          <v-icon>mdi-pencil-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-title>Plan bearbeiten</v-list-item-title>
      </v-list-item>
      <v-list-item @click="$router.push('/workouts')">
        <v-list-item-icon class="mr-3">
       <v-icon>mdi-history</v-icon>
        </v-list-item-icon>
        <v-list-item-title>Alte Ansicht</v-list-item-title>
      </v-list-item>
        <v-list-item @click="showOldPlansDialog = true">
    <v-list-item-icon class="mr-3">
      <v-icon>mdi-content-copy</v-icon>
    </v-list-item-icon>
    <v-list-item-title>Vergangene Trainingspläne</v-list-item-title>
  </v-list-item>
      <v-list-item @click="openDeleteDialog">
        <v-list-item-icon class="mr-3">
          <v-icon color="red darken-1">mdi-delete-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-title class="red--text text--darken-1">Plan löschen</v-list-item-title>
      </v-list-item>
      <v-list-item v-if="userService.getEmail() === 'sebs@wellcomefit.ch'"  @click="showPinDialog = true">
        <v-list-item-icon class="mr-3">
          <v-icon color="red darken-1">mdi-delete-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-title class="red--text text--darken-1">Smart Pin Testen</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</h4>
        <v-slide-group dark >

<v-slide-item>
  <div class="d-flex flex-column ma-2" style="gap: 8px;">
    
    <div @click="!isRefreshing && openFreeTrainingDialog()" class="tiktok-button free-training-button" :class="{ 'disabled-overlay': isRefreshing }">
      <div class="button-content">
        <v-progress-circular v-if="isRefreshing" indeterminate color="white" size="24"></v-progress-circular>
        <template v-else>
          <span class="emoji">💪</span>
          <h6 class="font-weight-bold">Freies Training</h6>
        </template>
      </div>
    </div>
    
    <div @click="!isRefreshing && startHyroxTraining()" class="tiktok-button hyrox-button" :class="{ 'disabled-overlay': isRefreshing }">
       <div class="button-content">
         <v-progress-circular v-if="isRefreshing" indeterminate color="white" size="24"></v-progress-circular>
         <h5 v-else class="font-weight-black">HYROX</h5>
      </div>
    </div>

  </div>
</v-slide-item>
         <v-slide-item v-for="(split, index) in workout.splits.workouts" :key="index">
  <v-card
    @click="selectSplit(split)"
    class="ma-2 rounded-xl start-split-card"
    height="160"
    width="130"
    :style="getSplitCardStyle(split.fixedVisualization)">
    
    <div class="d-flex flex-column fill-height pa-3 card-content">
      <h6 class="font-weight-bold white--text mb-0">{{ split.title }}</h6>
      <v-spacer></v-spacer>
      <v-img :src="split.fixedVisualization ? split.fixedVisualization.img : ''" height="80" width="80" contain class="align-self-end split-card-img" />
    </div>
  </v-card>
          </v-slide-item>
        </v-slide-group>
      </v-col>
    </v-row>


    <div class="tabs-container mx-0 mt-8" id="tour-step-3-target">
      <v-tabs v-model="tab" dark background-color="transparent" hide-slider grow>
        <v-tab>Trainings</v-tab>
        <v-tab>Übungen</v-tab>
      </v-tabs>
    </div>

    <div v-if="loading" class="mt-4">
      <div class="skeleton-card-stack">
        <div class="skeleton-card skeleton-loader"></div>
        <div class="skeleton-card skeleton-loader"></div>
        <div class="skeleton-card skeleton-loader"></div>
      </div>
    </div>
    
    <v-tabs-items v-else v-model="tab" class="transparent flex-grow-1" touchless>
      <v-tab-item class="fill-height">
        <WorkoutTimeline 
            v-if="stackedCardSessions && stackedCardSessions.length"
            :sessions="stackedCardSessions"
            :visualization-map="visualizationMap"
            @view-session="openDetailView"
            class="mt-4 fill-height" />
        <v-row v-else class="text-center white--text mt-10">
          <v-col>
            <v-icon color="grey">mdi-chart-timeline-variant</v-icon>
            <p class="grey--text mt-2">Noch keine Trainings absolviert.</p>
          </v-col>
        </v-row>
      </v-tab-item>
      
      <v-tab-item class="fill-height">
        <ExerciseExplorer 
            v-if="stackedCardExercises && stackedCardExercises.length"
            :exercises="stackedCardExercises"
            @view-exercise="openDetailView"
            class="mt-4 fill-height"
        />
        <v-row v-else class="text-center white--text mt-10">
          <v-col>
            <v-icon color="grey">mdi-weight-lifter</v-icon>
            <p class="grey--text mt-2">Noch keine Übungen getrackt.</p>
          </v-col>
        </v-row>
      </v-tab-item>
    </v-tabs-items>

    <TrainingsHubCardStack ref="detailViewer" :cards="[]" @session-deleted="deletedWorkoutSession()"  />
          <v-dialog v-model="freeTrainingDialog" fullscreen hide-overlay content-class="free-training-dialog" transition="dialog-bottom-transition">
        <v-card class="free-training-setup-card">
            <div class="gradient-bg-free-training"></div>
            <v-toolbar flat color="transparent" class="flex-grow-0">
                <v-btn icon dark @click="closeFreeTrainingDialog()"><v-icon>mdi-close</v-icon></v-btn>
            </v-toolbar>

            <div class="setup-content text-center d-flex flex-column justify-center">
                <div>
                            <v-img style="height: 10vh; margin-bottom: 20px;" contain src="/img/roody_logo.png"></v-img>

                    <h1 class="setup-title anim-fade-in-up">Freies Training</h1>
                    <p class="setup-subtitle anim-fade-in-up-delay">Gib deinem Workout einen Namen und wähle ein Design, das dich motiviert.</p>
                    
                    <v-text-field
                        v-model="freeTrainingName"
                        label="Workout-Name (z.B. Push Day)"
                        solo
                        dark
                        flat
                        hide-details
                        background-color="rgba(255, 255, 255, 0.08)"
                        class="mb-8 glass-textfield"
                    ></v-text-field>
                    
                    <h3 class="setup-subtitle anim-fade-in-up-delay-2">Wähle eine Darstellung</h3>
                    <v-slide-group v-model="selectedVisualizationIndex" class="mb-4" center-active :show-arrows="false">
                      <v-slide-item v-for="(vis, index) in visualizationOptions" :key="index" v-slot="{ active, toggle }">
                        <v-card 
                            @click="toggle" 
                            class="ma-2 vis-item-card" 
                            :class="{ 'vis-item-card--active': active }" 
                            width="120" 
                            height="120"
                            :style="{'--glow-color': vis.color}"
                        >
                          <v-img :src="vis.img" height="70" width="70" contain class="vis-item-img" />
                        </v-card>
                      </v-slide-item>
                    </v-slide-group>
                </div>
            </div>

            <div class="setup-actions" v-if="freeTrainingName && selectedVisualizationIndex !== null">
                <v-btn 
                    color="primary" 
                    x-large 
                    block 
                    rounded 
                    @click="startFreeTraining" 
                    :disabled="!freeTrainingName || selectedVisualizationIndex === null" 
                    class="start-btn-glow"
                >
                    <v-icon left>mdi-rocket-launch</v-icon>
                    Training starten
                </v-btn>
            </div>
        </v-card>
    </v-dialog>
    <v-dialog v-model="showDeleteConfirmDialog" max-width="450" persistent content-class="delete-dialog-card">
    <v-card class="text-center pa-5">
        <div class="delete-dialog-bg"></div>
        <v-icon size="100" color="red darken-1" class="delete-icon mb-4">mdi-alert-octagon-outline</v-icon>
        <h2 class="font-weight-bold text-h4 white--text mb-3">Bist du sicher?</h2>
        <p class="white--text text--lighten-1 mb-6">
            Wenn du deinen Trainingsplan löschst, werden <strong>alle zugehörigen Splits dauerhaft entfernt</strong>. Diese Aktion kann nicht rückgängig gemacht werden.
        </p>
        <v-row dense>
          <v-col cols="12">
            <v-btn large rounded block color="red darken-2" class="font-weight-bold" @click="confirmDeleteWorkout" :loading="isRefreshing">
              Endgültig löschen
            </v-btn>
          </v-col>
          <v-col cols="12">
              <v-btn large rounded block text @click="showDeleteConfirmDialog = false" class="font-weight-bold white--text">Abbrechen</v-btn>
          </v-col>
        </v-row>
    </v-card>
</v-dialog>
     <v-dialog v-model="hyroxDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
       <v-card class="hyrox-setup-card d-flex flex-column">
    <div class="gradient-bg-hyrox"></div>
    <v-toolbar flat color="transparent" class="flex-grow-0">
        <v-btn icon dark @click="hyroxDialog = false"><v-icon>mdi-close</v-icon></v-btn>
    </v-toolbar>

    <div class="setup-content text-center d-flex flex-column justify-center">
        <div>
            <h1 class="setup-title" style="color: white; font-size: 4rem">HYROX</h1>
            <h1 class="setup-title" style="color: #ffed00;">Challenge Accepted</h1>
            <p class="setup-subtitle">Wähle deine Wettkampf-Kategorie, um mit den offiziellen Gewichten zu trainieren.</p>
            
            <v-item-group class="mt-8" dark>
                <v-row dense>
                    <v-col v-for="category in hyroxCategories" :key="category.name" cols="6">
                        <v-item v-slot="{ active, toggle }">
                            <v-card @click="toggle(); selectHyroxCategory(category.name)" class="category-card" :class="{ 'category-active': active }">
                                <v-icon size="48" class="mb-2">{{ category.icon }}</v-icon>
                                <div class="font-weight-bold">{{ category.name }}</div>
                            </v-card>
                        </v-item>
                    </v-col>
                </v-row>
            </v-item-group>
        </div>
    </div>
</v-card>
    </v-dialog>
<v-dialog v-model="showContinueDialog" persistent max-width="420" dark content-class="rounded-xl wow-dialog-card">
    <v-card v-if="activeSplit && pendingSplit" class="rounded-xl overflow-hidden" :style="dialogCardStyle">
        <img :src="activeSplitVisualization.img" class="dialog-bg-image"></img>

        <div class="glass-overlay d-flex flex-column text-center pa-4 fill-height">
            <v-btn icon absolute top right class="mt-1 mr-1" @click="cancelDialog">
                <v-icon>mdi-close</v-icon>
            </v-btn>

            <div v-if="isSwitchingSplits">
                <h5 class="font-weight-bold text-h5 mb-4">Training wechseln?</h5>
                <div class="d-flex align-center justify-space-around my-4">
                    <div class="d-flex flex-column align-center">
                        <p class="mb-2 grey--text text--lighten-1 text-caption">Aktiv</p>
                        <v-avatar v-if="!activeSplit.title.includes('HYROX')" size="80" class="elevation-10 animated-avatar" :style="`border: 3px solid ${activeSplitVisualization.color}`">
                            <v-img :src="activeSplitVisualization.img" contain></v-img>
                        </v-avatar>
  <v-avatar v-else size="80" class="elevation-10 mx-auto mt-4 mb-3 animated-avatar" :style="`border: 3px solid ${activeSplitVisualization.color}`">
                    <v-icon size="60">{{ hyroxCategories.find(cat => activeSplit.title.includes(cat.fullName)).icon }}</v-icon>
                </v-avatar>
                        <h6 class="font-weight-bold mt-3" :style="{ color: activeSplitVisualization.color }">{{ activeSplit.title }}</h6>
                    </div>

                    <v-icon size="50" color="grey lighten-1">mdi-arrow-right-thin</v-icon>

                    <div class="d-flex flex-column align-center">
                        <p class="mb-2 grey--text text--lighten-1 text-caption">Neues Training</p>
                        <v-avatar v-if="!pendingSplit.title.includes('HYROX')" size="80" class="elevation-10 animated-avatar" :style="`border: 3px solid ${pendingSplitVisualization.color}`">
                            <v-img :src="pendingSplitVisualization.img" contain></v-img>
                        </v-avatar>
                         <v-avatar v-else size="80" class="elevation-10 mx-auto mt-4 mb-3 animated-avatar" :style="`border: 3px solid ${pendingSplitVisualization.color}`">
                    <v-icon size="60">{{ hyroxCategories.find(cat => pendingSplit.title.includes(cat.fullName)).icon }}</v-icon>
                </v-avatar>
                        <h6 class="font-weight-bold mt-3" :style="{ color: pendingSplitVisualization.color }">{{ pendingSplit.title }}</h6>
                    </div>
                    
                  </div>
                  <p class="white--text font-weight-light">Möchtest du einen neuen Split starten oder deinen aktiven fortsetzen?</p>
            </div>

            <div v-else>
                <v-avatar v-if="!activeSplit.title.includes('HYROX')" size="90" class="elevation-10 mx-auto mt-4 mb-3 animated-avatar" :style="`border: 3px solid ${activeSplitVisualization.color}`">
                    <v-img :src="activeSplitVisualization.img" contain></v-img>
                </v-avatar>
                <v-avatar v-else size="90" class="elevation-10 mx-auto mt-4 mb-3 animated-avatar" :style="`border: 3px solid ${activeSplitVisualization.color}`">
                    <v-icon size="60">{{ hyroxCategories.find(cat => activeSplit.title.includes(cat.fullName)).icon }}</v-icon>
                </v-avatar>
             <h5 class="font-weight-bold text-h5 mb-1" :style="{ color: activeSplitVisualization.color }">{{ activeSplit.title }}</h5>
                <p class="white--text font-weight-light">Möchtest du dieses Training neu starten?</p>
            </div>


            <v-chip v-if="activeWorkoutElapsedTime" small class="mx-auto my-3" label color="rgba(255, 255, 255, 0.15)">
                <v-icon left small>mdi-clock-outline</v-icon>
                Aktuell läuft seit {{ activeWorkoutElapsedTime }}
            </v-chip>

            <v-spacer></v-spacer>

            <v-card-actions class="pa-0 d-flex flex-column align-stretch">
                <v-btn
         depressed
                    x-large
                    rounded
                    class="font-weight-bold pulse-animation mb-3 white--text"
                    :color="activeSplitVisualization.color"
                    :class="continueButtonTextClass"
                    @click="continueWorkout"
                >
                    Fortsetzen
                </v-btn>

                <v-btn dark small text @click="discardAndStartNew">
                    <v-icon left small v-if="isSwitchingSplits">mdi-swap-horizontal</v-icon>
                    <v-icon left small v-else>mdi-restart</v-icon>
                    <span v-if="isSwitchingSplits">Verwerfen & wechseln</span>
                    <span v-else>Verwerfen & neu starten</span>
                </v-btn>
            </v-card-actions>
        </div>
    </v-card>
</v-dialog>
<OldPlansManagerDialog 
  :value="showOldPlansDialog" 
  :current-plan="workout"
  @close="showOldPlansDialog = false"
  @plan-updated="handlePlanUpdate"
/>
<v-dialog v-if="workout && workout.splits" v-model="showDownloadDialog" max-width="500" dark>
      <v-card class="glass-card">
        <v-card-title class="font-weight-bold">Split als PDF herunterladen</v-card-title>
        <v-list color="transparent">
          <v-list-item v-for="(split, index) in workout.splits.workouts" :key="index" @click="downloadSplit(index)" link>
            <v-list-item-icon>
              <v-icon color="primary">mdi-download</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ split.title }}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-icon>mdi-chevron-right</v-icon>
            </v-list-item-action>
          </v-list-item>
        </v-list>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="showDownloadDialog = false">Schliessen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showCancelDialog" persistent max-width="420" dark content-class="rounded-xl wow-dialog-card">
    <v-card class="rounded-xl overflow-hidden glass-overlay">
        <div class="pa-8 text-center">
            <v-icon size="80" color="orange" class="mb-4 animated-icon">mdi-alert-circle-outline</v-icon>
            <h2 class="text-h5 font-weight-bold mb-3">Aktives Training verwerfen?</h2>
            <p class="body-1 grey--text text--lighten-1 mb-6">
                Wenn du fortfährst, wird dein aktueller Trainingsfortschritt zurückgesetzt. Diese Aktion kann nicht rückgängig gemacht werden.
            </p>
            <v-row dense>
                <v-col cols="6">
                    <v-btn large rounded block text @click="showCancelDialog = false">Abbrechen</v-btn>
                </v-col>
                <v-col cols="6">
                    <v-btn large rounded block depressed color="orange" class="font-weight-bold" @click="confirmCancelWorkout">
                        Verwerfen
                    </v-btn>
                </v-col>
            </v-row>
        </div>
    </v-card>
</v-dialog>

    <PinConnectorDialog 
      :value="showPinDialog" 
      @close="showPinDialog = false" 
    />
  </v-container>
</template>
<script>
import api from "@/api";
import TrainingsHubCardStack from "./trainingsHubCardStack.vue";
import TrainingCalendar from "./trainingCalendar.vue";
import { mapState, mapGetters, mapActions } from "vuex";
import HubTour from "./trainingsHubTour.vue";
import PlanConverter from "./planConverter.vue";
import WorkoutTimeline from "./trainingsHubWorkoutTimeline.vue";
import ExerciseExplorer from "./trainingsHubExerciseExplorer.vue";
import PinConnectorDialog from './pinConnectorDialog.vue';
import OldPlansManagerDialog from './OldPlansManagerDialog.vue'; // Pfad ggf. anpassen

import userService from "@/services/userService"
import moment from "moment";

function getLuminance(hexColor) {
  if (!hexColor) return 0;
  hexColor = hexColor.replace("#", "");
  const r = parseInt(hexColor.substring(0, 2), 16);
  const g = parseInt(hexColor.substring(2, 4), 16);
  const b = parseInt(hexColor.substring(4, 6), 16);
  return 0.299 * r + 0.587 * g + 0.114 * b;
}

export default {
  name: "TrainingsHub",
  components: {
    WorkoutTimeline,
    ExerciseExplorer,
    TrainingsHubCardStack,
    TrainingCalendar,
    HubTour,
    PlanConverter,
    PinConnectorDialog,
    OldPlansManagerDialog
  },
  data() {
    return {
      userService,
      showOldPlansDialog: false,
      timerInterval: null,
      elapsedTime: "00:00",
      showCancelDialog: false,
      showPinDialog: false,
      showDownloadDialog: false,
      showDeleteConfirmDialog: false,
      tab: null,
      showContinueDialog: false,
      pendingSplit: null,
      loading: false, // Für den Skeleton-Loader beim allerersten Laden
      isRefreshing: false, // Für den Progress-Circle beim manuellen Refresh
      showTour: false,
      showConversionDialog: false,
      freeTrainingDialog: false,
      freeTrainingName: "",
      selectedVisualizationIndex: null,
      visualizationOptions: [
        { name: 'Beine', img: "/img/workout/legSplit.png", color: "#1C4966" },
        { name: 'Brust', img: "/img/workout/chestSplit.png", color: "#02734A" },
        { name: 'Rücken', img: "/img/workout/backSplit.png", color: "#F2B950" },
        { name: 'Arme', img: "/img/workout/armSplit.png", color: "#E5735D" },
        { name: 'Cardio', img: "/img/workout/cardioSplit.png", color: "#F7B5A7" },
        { name: 'Ganzkörper', img: "/img/workout/upperBodySplit.png", color: "#A3C6C4" },
      ],
      showSuccessPopup: false,
      hyroxDialog: false,
      hyroxCategories: [
        { name: 'Men', icon: 'mdi-human-male', fullName: 'HYROX (Men)' },
        { name: 'Men Pro', icon: 'mdi-crown', fullName: 'HYROX (Men Pro)' },
        { name: 'Women', icon: 'mdi-human-female', fullName: 'HYROX (Women)' },
        { name: 'Women Pro', icon: 'mdi-crown-outline', fullName: 'HYROX (Women Pro)' },
      ],
    };
  },
  computed: {
    ...mapGetters("deviceStore", ["exerciseList"]),
    ...mapState("runWorkoutStore", ["activeSplit", "workoutStartTime"]),
    ...mapGetters("runWorkoutStore", {
      workout: "hubWorkoutPlan",
      groupedSessions: "hubGroupedSessions",
      groupedExercises: "hubGroupedExercises",
      oldWorkoutPlans: "oldWorkoutPlans",
    }),
    activeWorkoutExists() {
      return this.activeSplit && this.workoutStartTime;
    },
    activeWorkoutElapsedTime() {
      return this.elapsedTime;
    },
    isSwitchingSplits() {
      if (!this.activeSplit || !this.pendingSplit) return false;
      return this.activeSplit.title !== this.pendingSplit.title;
    },
    pendingSplitVisualization() {
      if (this.pendingSplit && this.pendingSplit.fixedVisualization) return this.pendingSplit.fixedVisualization
      if (this.pendingSplit && this.pendingSplit.title) {
        return this.getTrainingPlanVisualization(this.pendingSplit.title);
      }
      return { color: "#333333", img: null };
    },
    visualizationMap() {
      const map = {};
      if (!this.groupedSessions) return map;
      this.groupedSessions.forEach(session => {
        if (session.execution) {
          map[session.execution.title] = this.getTrainingPlanVisualization(session.execution.title);
        }
      });
      return map;
    },
    dialogCardStyle() {
      if (!this.activeSplitVisualization || !this.activeSplitVisualization.color) {
        return {};
      }
      const color = this.activeSplitVisualization.color;
      return {
        "box-shadow": `0px 10px 40px -10px ${color}99`,
      };
    },
    activeSplitVisualization() {
      if (this.activeSplit && this.activeSplit.fixedVisualization) return this.activeSplit.fixedVisualization
      if (this.activeSplit && this.activeSplit.title) {
        return this.getTrainingPlanVisualization(this.activeSplit.title);
      }
      return { color: "#333333", img: null };
    },
    continueButtonTextClass() {
      const luminance = getLuminance(this.activeSplitVisualization.color);
      return luminance > 140 ? "black--text" : "white--text";
    },
    stackedCardSessions() {
      return this.groupedSessions
        .filter((session) => session.execution)
        .map((card) => {
          card.backgroundColor = this.getTrainingPlanVisualization(card.execution.title).color;
          card.img = this.getTrainingPlanVisualization(card.execution.title).img;
          return card;
        });
    },
    stackedCardExercises() {
     return this.groupedExercises.filter((item) => item && item.exercise).map((item) => {
      const newItem = { ...item };
      let exId = newItem.exercise;
      if (typeof exId === 'object' && exId !== null) {
         exId = exId._id; 
      }
      const fullExerciseData = this.exerciseList.find((ex) => ex._id === exId);
      newItem.exercise = fullExerciseData;
      return newItem;
    })
    .filter(item => item.exercise); 
},
  },
  watch: {
    showSuccessPopup(newValue) {
      if (newValue) {
        this.$nextTick(() => {
          if (this.$confetti) {
            this.$confetti.start({
              particlesPerFrame: 0.5,
              defaultDropRate: 10,
              defaultSize: 8,
            });
          }
        });
      } else {
        if (this.$confetti) {
          this.$confetti.stop();
        }
      }
    }
  },
  async created() {
    if (this.$route.query.updated === 'true') {
      this.showSuccessPopup = true;
      this.$router.replace({ query: null }).catch(() => {});
    }

    if (this.workout && this.groupedSessions.length > 0) {
      this.loading = false;
      
      this.refreshDataInBackground(); 
    } else {
      this.loading = true;
      await this.initialLoad(); 
    }
    
    // Unabhängige API-Aufrufe, die die UI nicht blockieren
    api.fetchDevices().then((deviceList) => {
      deviceList.forEach((e) => (e.fab = false));
      this.setDeviceList(JSON.parse(JSON.stringify(deviceList)));
    });

    // Flutter Handler
    if (window.flutter_inappwebview) {
      console.log("Rufe 'startPinScan' Handler in Flutter auf...");
      window.flutter_inappwebview.callHandler('startPinScan');
    } else {
      console.warn("Flutter-Handler nicht verfügbar. App läuft wahrscheinlich im Browser.");
    }
  },
  mounted() {
    this.startTimer();
  },
  beforeDestroy() {
    this.stopTimer();
  },
  methods: {
    ...mapActions("runWorkoutStore", ["setActiveSplit", "resetWorkoutState", "setActivePlanID", "loadHubData", "setPlanForEditing", "initiateFreeTraining", "loadOldPlans"]),
    ...mapActions("deviceStore", ["setDeviceList"]),
 handlePlanUpdate() {
      this.showOldPlansDialog = false;
      this.$toast.success("Split wurde erfolgreich zum aktuellen Plan hinzugefügt!");
      this.refreshDataInBackground(); // Bestehende Methode nutzen, um die Ansicht zu aktualisieren
    },
    async initialLoad() {
      this.isRefreshing = true;
      try {
        if (!this.workout) {
          await this.loadOldPlans();
        }
        await this.loadHubData();
      } catch (error) {
        console.error("Fehler beim initialen Laden des TrainingsHub:", error);
      } finally {
        this.loading = false;
        this.isRefreshing = false;
        this.checkAndShowTour();
      }
    },
    
    // Methode für die nicht-blockierende Hintergrund-Aktualisierung
  async refreshDataInBackground() {
      this.isRefreshing = true; // Kleiner Lade-Kringel oben rechts
      try {
        await this.loadHubData(); // Ruft jetzt die optimierte Action auf
      } catch (error) {
        console.error("Silent Refresh failed", error);
      } finally {
        this.isRefreshing = false;
        this.checkAndShowTour();
      }
    },
    // Logik zur Anzeige der Tour, wird nach dem Laden aufgerufen
    checkAndShowTour() {
      if (!this.workout) {
        this.showTour = true;
      } else if (!localStorage.getItem("hubTourCompleted")) {
        this.showTour = true;
      }
    },

    promptCancelWorkout() {
      this.showCancelDialog = true;
    },
    async confirmCancelWorkout() {
      await this.resetWorkoutState();
      this.showCancelDialog = false;
      this.$toast.info("Das aktive Training wurde verworfen.");
    },
    startTimer() {
      this.stopTimer();
      this.timerInterval = setInterval(() => {
        if (this.workoutStartTime) {
          const duration = moment.duration(moment().diff(this.workoutStartTime));
          const hours = Math.floor(duration.asHours());
          const minutes = String(duration.minutes()).padStart(2, '0');
          const seconds = String(duration.seconds()).padStart(2, '0');
          
          if (hours > 0) {
            this.elapsedTime = `${hours}:${minutes}:${seconds}`;
          } else {
            this.elapsedTime = `${minutes}:${seconds}`;
          }
        }
      }, 1000);
    },
    stopTimer() {
      if (this.timerInterval) {
        clearInterval(this.timerInterval);
        this.timerInterval = null;
      }
    },
    downloadSplit(index) {
      if (this.workout && this.workout._id) {
        this.$toast.info("Dein Download wird vorbereitet...")
        api.downloadSplitPDF(this.workout._id, index)
        this.showDownloadDialog = false
      }
    },
    openDeleteDialog() {
      this.showDeleteConfirmDialog = true;
    },
    closeFreeTrainingDialog() {
      this.freeTrainingDialog = false
    },
    async confirmDeleteWorkout() {
      if (!this.workout || !this.workout._id) return;
      
      this.isRefreshing = true;
      try {
        await api.workoutApi.deleteWorkoutV2(this.workout._id);
        
        await this.resetWorkoutState();
        await this.loadHubData();
        
        if (!this.workout) {
          this.showTour = true;
        }
      } catch (error) {
        console.error("Fehler beim Löschen des Trainingsplans:", error);
      } finally {
        this.showDeleteConfirmDialog = false;
        this.isRefreshing = false;
      }
    }, 
    async deletedWorkoutSession() {
      console.log('hallooooo')
      this.isRefreshing = true;
      try {
        this.$store.commit('runWorkoutStore/SET_HUB_DATA', {
        workout: this.workout,
        groupedSessions: [],
        groupedExercises: []
    });
        await this.loadHubData();
        
      } catch (error) {
        console.log(error)
      } finally {
        this.isRefreshing = false;
      }
    },
    openFreeTrainingDialog() {
      this.freeTrainingDialog = true;
    },
    async startFreeTraining() {
      this.showTour = false
      if (!this.freeTrainingName || this.selectedVisualizationIndex === null) return;
      
      const selectedVis = this.visualizationOptions[this.selectedVisualizationIndex];
      const freeSplit = {
        title: this.freeTrainingName,
        isFreeTraining: true,
        fixedVisualization: {
          color: selectedVis.color,
          img: selectedVis.img
        },
        exercises: []
      };
      
      if (this.workout && this.workout._id) {
        this.setActivePlanID(this.workout._id);
      }

      let planID = this.workout ? JSON.parse(JSON.stringify(this.workout._id)) : null;
      freeSplit.planID = planID;

      await this.initiateFreeTraining(freeSplit, planID);
      this.freeTrainingDialog = false;
      this.freeTrainingName = "";
      this.selectedVisualizationIndex = null;
      this.$router.push({ name: "Workout_run" }); 
    },
    startHyroxTraining() {
      this.hyroxDialog = true;
    },
    async selectHyroxCategory(category) {
      const getExById = (id) => this.exerciseList.find(ex => ex._id === id);
      const weights = {
        'Men Pro':    { sledPush: 152, sledPull: 103, farmersCarry: 32, sandbagLunges: 30, wallBalls: 9 },
        'Men':        { sledPush: 102, sledPull: 78,  farmersCarry: 24, sandbagLunges: 20, wallBalls: 6 },
        'Women Pro':  { sledPush: 102, sledPull: 78,  farmersCarry: 24, sandbagLunges: 20, wallBalls: 6 },
        'Women':      { sledPush: 78,  sledPull: 52,  farmersCarry: 16, sandbagLunges: 10, wallBalls: 4 },
        'Üben':       { sledPush: null, sledPull: null, farmersCarry: null, sandbagLunges: null, wallBalls: null }
      };
      const selectedWeights = weights[category];

      const createExerciseList = () => [
          { exercise: getExById('6224b5abfd146d2a56f8ce03'), title: "1km Run", sets: [[{ text: "Distanz", value: 1000 }]] },
          { exercise: getExById('6224b6091e25242b09563692'), title: "SkiErg", sets: [[{ text: "Distanz", value: 1000 }]] },
          { exercise: getExById('6224b5abfd146d2a56f8ce03'), title: "1km Run", sets: [[{ text: "Distanz", value: 1000 }]] },
          { exercise: getExById('67bed49c7fe2e50b8f5c0871'), title: "Sled Push", sets: [[{ text: "Gewicht", value: selectedWeights.sledPush }, { text: "Distanz", value: 50 }]] },
          { exercise: getExById('6224b5abfd146d2a56f8ce03'), title: "1km Run", sets: [[{ text: "Distanz", value: 1000 }]] },
          { exercise: getExById('679e9ce85fd3ec7a5f63e8b3'), title: "Sled Pull", sets: [[{ text: "Gewicht", value: selectedWeights.sledPull }, { text: "Distanz", value: 50 }]] },
          { exercise: getExById('6224b5abfd146d2a56f8ce03'), title: "1km Run", sets: [[{ text: "Distanz", value: 1000 }]] },
          { exercise: getExById('67beccea7fe2e50b8f5bfd6e'), title: "Burpee Broad Jumps", sets: [[{ text: "Distanz", value: 80 }]] },
          { exercise: getExById('6224b5abfd146d2a56f8ce03'), title: "1km Run", sets: [[{ text: "Distanz", value: 1000 }]] },
          { exercise: getExById('6224b5abfd146d2a56f8cdd2'), title: "Rudern", sets: [[{ text: "Distanz", value: 1000 }]] },
          { exercise: getExById('6224b5abfd146d2a56f8ce03'), title: "1km Run", sets: [[{ text: "Distanz", value: 1000 }]] },
          { exercise: getExById('67bed49c7fe2e50b8f5c086c'), title: "Farmer's Carry", sets: [[{ text: "Gewicht", value: selectedWeights.farmersCarry }, { text: "Distanz", value: 200 }]] },
          { exercise: getExById('6224b5abfd146d2a56f8ce03'), title: "1km Run", sets: [[{ text: "Distanz", value: 1000 }]] },
          { exercise: getExById('67bed1017fe2e50b8f5c0176'), title: "Sandbag Lunges", sets: [[{ text: "Gewicht", value: selectedWeights.sandbagLunges }, { text: "Distanz", value: 100 }]] },
          { exercise: getExById('6224b5abfd146d2a56f8ce03'), title: "1km Run", sets: [[{ text: "Distanz", value: 1000 }]] },
          { exercise: getExById('679f4cf8d77dade567868919'), title: "Wall Balls", sets: [[{ text: "Gewicht", value: selectedWeights.wallBalls }, { text: 'Wiederholungen', value: 100 }]] },
        ]
        .filter(ex => ex.exercise)
        .map(ex => ({ ...ex.exercise, title: ex.title, sets: ex.sets }));

      const hyroxSplit = {
        title: `HYROX (${category})`,
        isFreeTraining: true,
        isHyrox: true,
        isCompetition: category !== 'Üben',
        fixedVisualization: {
          color: '#ffed00',
          img: '/img/hyrox_logo.png'
        },
        exercises: createExerciseList()
      };

      this.selectSplit(hyroxSplit);
    },
    closeSuccessPopup() {
      this.showSuccessPopup = false
      if (this.$confetti) this.$confetti.stop();
    },
    goToEditPlan() {
      if (this.workout && this.workout._id) {
        this.setPlanForEditing({ form: this.workout });
        this.$router.push({ name: 'WorkoutCreateNew', params: { id: this.workout._id } });
      }
    },
    async goToCreatePlan() {
      await this.resetWorkoutState();
      this.openFreeTrainingDialog()
    },
    
    openDetailView(itemData, event) {
      if (this.$refs.detailViewer && event.currentTarget) {
        this.$refs.detailViewer.expandCardFromTarget(itemData, event.currentTarget);
      }
    },
    handleTourComplete() {
      this.showTour = false;
      localStorage.setItem("hubTourCompleted", "true");
    },
    cancelDialog() {
      this.showContinueDialog = false;
      this.pendingSplit = null;
    },
    selectSplit(split) {
      if (this.activeSplit && this.workoutStartTime) {
        this.pendingSplit = split;
        this.showContinueDialog = true;
      } else {
        this.startNewWorkout(split);
      }
    },
    continueWorkout() {
      this.showContinueDialog = false;
      this.setActivePlanID(this.workout._id);
      this.$router.push({ name: "Workout_run" });
    },
    async discardAndStartNew() {
      await this.resetWorkoutState();
      this.showContinueDialog = false;
      if (this.pendingSplit) {
        this.startNewWorkout(this.pendingSplit);
        this.pendingSplit = null;
      }
    },
    async startNewWorkout(split) {
      await this.resetWorkoutState();
      this.setActivePlanID(this.workout._id);
      this.setActiveSplit(split);
      this.$router.push({ name: "Workout_run" });
    },
    getSplitCardStyle(visualization) {
      if (!visualization || !visualization.color) {
        return { background: "#333" };
      }
      const darkenColor = (color, percent) => {
        let f = parseInt(color.slice(1), 16),
          t = percent < 0 ? 0 : 255,
          p = percent < 0 ? percent * -1 : percent,
          R = f >> 16,
          G = (f >> 8) & 0x00ff,
          B = f & 0x0000ff;
        return ("#" + (0x1000000 + (Math.round((t - R) * p) + R) * 0x10000 + (Math.round((t - G) * p) + G) * 0x100 + (Math.round((t - B) * p) + B)).toString(16).slice(1));
      };
      const color2 = darkenColor(visualization.color, 0.4);
      return { background: `linear-gradient(135deg, ${visualization.color} 0%, ${color2} 100%)` };
    },
    getTrainingPlanVisualization(title) {
      const lowerName = title.toLowerCase();
      const keywords = {
        leg: ["bein", "beine", "unterkörper"],
        chest: ["brust", "push"],
        back: ["rücken", "pull", "schulter"],
        arm: ["arm", "arme", "bizeps", "trizeps"],
        core: ["bauch", "core", "ober"],
      };
      if (keywords.leg.some(k => lowerName.includes(k))) return { img: "/img/workout/legSplit.png", color: "#1C4966" };
      if (keywords.chest.some(k => lowerName.includes(k))) return { img: "/img/workout/chestSplit.png", color: "#02734A" };
      if (keywords.back.some(k => lowerName.includes(k))) return { img: "/img/workout/backSplit.png", color: "#F2B950" };
      if (keywords.arm.some(k => lowerName.includes(k))) return { img: "/img/workout/armSplit.png", color: "#E5735D" };
      if (keywords.core.some(k => lowerName.includes(k))) return { img: "/img/workout/cardioSplit.png", color: "#F7B5A7" };
      return { img: "/img/workout/upperBodySplit.png", color: "#A3C6C4" };
    },
  },
  beforeRouteLeave (to, from, next) {
    if (this.$refs.detailViewer.showClone) {

      this.$refs.detailViewer.closeClone()
    } else {
    next()
    }
  }
};
</script>

<style lang="scss" scoped>
.disabled-overlay {
  cursor: not-allowed;
  opacity: 0.7;
  pointer-events: none; /* Klicks komplett unterbinden */
}
.tiktok-button {
  width: 130px;
  height: 76px; /* Höhe pro Button (160px Gesamthöhe - 8px Lücke) / 2 */
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  border-radius: 18px; /* Etwas runder für einen modernen Look */
  position: relative;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.2s ease-out, box-shadow 0.3s ease;
  z-index: 1; /* Wichtig für den Hover-Effekt */
}

.menu-list-custom {
  background-color: #2c2c2c !important;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px !important;
  backdrop-filter: blur(10px);
}

/* NEU: Styling für den "geilen" Löschen-Dialog */
.delete-dialog-card {
  background-color: transparent !important;
  box-shadow: none !important;
  overflow: visible !important; /* Wichtig für den Glow-Effekt */
}

.delete-dialog-card .v-card {
  border-radius: 24px !important;
  background: #1e1e1e;
  border: 1px solid rgba(255, 82, 82, 0.3);
  position: relative;
  overflow: hidden;
  box-shadow: 0 10px 40px rgba(255, 82, 82, 0.2);
}

.delete-dialog-bg {
  position: absolute;
  top: 0; left: 0; width: 100%; height: 100%;
  background: radial-gradient(circle at 50% 0%, rgba(255, 82, 82, 0.15), transparent 70%);
  pointer-events: none;
}

.delete-icon {
  animation: alert-icon-pop 0.8s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
}

@keyframes alert-icon-pop {
  0% { transform: scale(0.6) rotate(-15deg); opacity: 0; }
  60% { transform: scale(1.1) rotate(10deg); opacity: 1; }
  100% { transform: scale(1) rotate(0deg); opacity: 1; }
}

.tiktok-button .button-content {
  position: relative;
  z-index: 2; /* Stellt sicher, dass der Inhalt immer über den Effekten ist */
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.tiktok-button:hover {
  transform: translateY(-4px) scale(1.03); /* Dynamischer Hover-Effekt */
}

/* Spezifische Styles für "Freies Training" mit "WOW"-Effekt */
.free-training-button {
  background: linear-gradient(110deg, #3a7bd5, #3a6073, #1e3c72);
  background-size: 200% 200%;
  animation: background-pan 6s linear infinite;
  box-shadow: 0 5px 15px rgba(58, 123, 213, 0.4);
}
.free-training-button:hover {
  box-shadow: 0 8px 25px rgba(58, 123, 213, 0.6);
}
.free-training-button .emoji {
  font-size: 2.2rem;
  line-height: 1;
  animation: pulse-icon 2.5s infinite ease-in-out; /* Pulsierende Rakete */
}
.free-training-button h6 {
  font-size: 0.8rem;
  line-height: 1.1;
  margin-top: 2px;
}

/* Spezifische Styles für "HYROX" mit starkem Glow */
.hyrox-button {
  background: #1A1A1A;
  /* Der gewünschte, starke Glow-Effekt */
  box-shadow: 0 0 10px #ffed00, 
              0 0 20px rgba(255, 237, 0, 0.4),
              inset 0 0 10px rgba(255, 237, 0, 0.2);
}
.hyrox-button:hover {
  background: #222;
  box-shadow: 0 0 15px #ffed00, 
              0 0 30px #ffed00,
              0 0 45px rgba(255, 237, 0, 0.5);
}
.hyrox-button h5 {
  color: white;
  font-size: 1.6rem !important;
  text-shadow: 0 0 4px #fff, 0 0 12px #ffed00;
  text-transform: uppercase;
  font-weight: 900 !important;
  letter-spacing: 1px;
}

/* Animation für den Hintergrund des oberen Buttons */
@keyframes background-pan {
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}

/* Die bestehende pulse-icon Animation (falls du sie entfernt hast) */
@keyframes pulse-icon {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.1); }
}
.free-training-vis-card {
  transition: all 0.2s ease-in-out;
  border: 3px solid transparent;
}

.free-training-vis-card.vis-active {
  border-color: var(--v-primary);
  transform: scale(1.1);
  box-shadow: 0 0 25px rgba(0, 150, 63, 0.6);
}
.glass-card {
  background: rgba(40, 40, 40, 0.8) !important;
  backdrop-filter: blur(15px);
  -webkit-backdrop-filter: blur(15px);
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
}
.free-training-setup-card {
  background: linear-gradient(145deg, #2a2a2a, #1a1a1a);
  display: flex;
  flex-direction: column;
}
.setup-content {
  flex-grow: 1;
  padding: 0 24px;
  overflow-y: auto;
}
.setup-title {
  font-size: 2.8rem;
  font-weight: 800;
  line-height: 1.2;
  margin-bottom: 8px;
}
.setup-subtitle {
  font-size: 1.1rem;
  color: white;
  margin-bottom: 24px;
}
.setup-actions {
  padding: 16px 24px;
  background: linear-gradient(to top, rgba(26, 26, 26, 1) 50%, rgba(26, 26, 26, 0));
}
.start-btn-glow {
  box-shadow: 0 0 20px rgba(0, 150, 63, 0.5);
}
.gradient-bg {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: radial-gradient(circle at 15% 25%, rgba(0, 150, 63, 0.1), transparent 45%);
  pointer-events: none;
}
@keyframes gradient-flow {
    0% { background-position: 0% 50%; }
    50% { background-position: 100% 50%; }
    100% { background-position: 0% 50%; }
}
@keyframes pulse-icon {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.1); }
}
.skeleton-loader {
  background-color: #2a2a2a;
  background-image: linear-gradient(90deg, #2a2a2a 0px, #3a3a3a 40px, #2a2a2a 80px);
  background-size: 400px;
  animation: shimmer 1.5s infinite linear;
}
.skeleton-text {
  background-color: #2a2a2a;
  border-radius: 8px;
  background-image: linear-gradient(90deg, #2a2a2a 0px, #3a3a3a 80px, #2a2a2a 160px);
  background-size: 600px;
  animation: shimmer 2s infinite linear;
  margin-bottom: 16px;
}
.skeleton-card-stack {
  position: relative;
  width: 100%;
  height: 290px;
  perspective: 1500px;
}
.skeleton-card {
  position: absolute;
  width: 100%;
  height: 250px;
  border-radius: 28px;
  transform-origin: center top;
}
.skeleton-card:nth-child(1) { top: 0; z-index: 3; }
.skeleton-card:nth-child(2) { top: 20px; z-index: 2; transform: scale(0.95); filter: brightness(0.9); }
.skeleton-card:nth-child(3) { top: 40px; z-index: 1; transform: scale(0.9); filter: brightness(0.8); }
@keyframes shimmer {
  0% { background-position: -200px 0; }
  100% { background-position: 200px 0; }
}
.trainings-hub {
  background-color: rgb(30, 30, 30);
  color: white;
  min-height: 100vh;
}
.transparent {
  background-color: transparent !important;
}
.start-split-card {
  transition: all 0.3s ease-in-out;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  overflow: hidden;
  position: relative;
}
.card-content {
  position: relative;
  z-index: 1;
}
.start-split-card:hover {
  transform: translateY(-5px) scale(1.03);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);
}
.start-split-card::before {
  content: "";
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background-image: radial-gradient(circle at top right, rgba(255, 255, 255, 0.25), transparent 40%);
  opacity: 0;
  transition: opacity 0.4s ease;
  z-index: 0;
}
.split-card-img {
  position: absolute;
  bottom: 5px;
  right: 5px;
  filter: drop-shadow(0px 5px 10px rgba(0, 0, 0, 0.3));
  transition: transform 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}
.start-split-card:hover .split-card-img {
  transform: scale(1.15) rotate(8deg);
}
.tabs-container {
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 24px;
  padding: 4px;
  backdrop-filter: blur(10px);
}
::v-deep .v-tab {
  color: rgba(255, 255, 255, 0.7) !important;
  border-radius: 20px;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  text-transform: none;
  font-weight: 600;
}
::v-deep .v-tab--active {
  background-color: #f5f5f5;
  color: #121212 !important;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}
::v-deep .v-tab::before {
  display: none;
}
.dialog-bg-image {
  position: absolute;
  top: 0; left: 0; width: 100%; height: 100%;
  filter: blur(20px) brightness(0.7);
  transform: scale(1.2);
}
.glass-overlay {
  position: relative;
  z-index: 1;
  background: rgba(42, 42, 42, 0.6);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
}
.animated-avatar {
  animation: scale-in 0.7s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}
.pulse-animation {
  animation: pulse 2s infinite;
  box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.7);
}
@keyframes scale-in {
  from { transform: scale(0.5); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
}
@keyframes pulse {
  0% { transform: scale(0.98); box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.4); }
  70% { transform: scale(1); box-shadow: 0 0 0 10px rgba(255, 255, 255, 0); }
  100% { transform: scale(0.98); box-shadow: 0 0 0 0 rgba(255, 255, 255, 0); }
}
::v-deep .wow-dialog-card {
  background-color: transparent !important;
  box-shadow: none !important;
}
.hub-action-btn {
  color: white !important;
  font-weight: bold;
  border: 2px solid transparent;
  transition: all 0.3s ease-in-out;
  text-transform: none;
  letter-spacing: 0.5px;
}
.edit-btn {
  background-image: linear-gradient(135deg, #424242 0%, #616161 100%);
  border-color: #757575;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}
.edit-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(150, 150, 150, 0.3);
}
.create-btn {
  background-image: linear-gradient(135deg, var(--v-primary-base) 0%, color-mix(in srgb, var(--v-primary-base) 60%, black) 100%);
  border-color: var(--v-primary-lighten1);
  box-shadow: 0 4px 15px rgba(0, 150, 63, 0.3);
}
.create-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 150, 63, 0.4);
}
.success-popup-card {
  background: #2E2E2E;
  border-radius: 24px !important;
  border: 1px solid rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(15px);
  background-color: rgba(46, 46, 46, 0.8) !important;
}
.success-icon {
    animation: success-icon-pop 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;
}
@keyframes success-icon-pop {
    0% { transform: scale(0.5); opacity: 0; }
    60% { transform: scale(1.1); opacity: 1; }
    100% { transform: scale(1); opacity: 1; }
}
::v-deep .v-dialog__content .v-dialog {
    background: transparent !important;
}
.hyrox-setup-card {
  background: #000;
  display: flex;
  flex-direction: column;
  animation: dialog-slide-up 0.7s cubic-bezier(0.16, 1, 0.3, 1) forwards;
  overflow: hidden;
}

.gradient-bg-hyrox {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: radial-gradient(circle at 50% 100%, rgba(255, 237, 0, 0.2), transparent 50%);
  animation: aurora-glow 1.5s 0.5s forwards;
  pointer-events: none;
}

.hyrox-logo-glow {
  filter: drop-shadow(0 0 15px #ffed00);
  animation: fade-in-up 0.8s 0.8s cubic-bezier(0.19, 1, 0.22, 1) forwards;
  opacity: 0;
}



.category-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 140px;
  background-color: rgba(255, 255, 255, 0.05) !important;
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.2s ease-in-out !important;
  cursor: pointer;
  border-radius: 16px !important;
  position: relative;
  overflow: hidden;
}

.category-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: -150%;
    width: 75%;
    height: 100%;
    background: linear-gradient(to right, transparent 0%, rgba(255,237,0,0.2) 50%, transparent 100%);
    transform: skewX(-25deg);
    transition: left 0.8s ease;
}
.category-card:hover::before {
    left: 150%;
}

.category-card.category-active {
  background-color: rgba(255, 237, 0, 0.1) !important;
  border-color: #ffed00;
  transform: scale(1.05);
  box-shadow: 0 0 25px rgba(255, 237, 0, 0.5);
}
/* --- NEUES STYLING FÜR "FREIES TRAINING"-DIALOG --- */

::v-deep .free-training-dialog {
  animation: dialog-slide-up 0.7s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

.free-training-setup-card {
  background: #101010;
  display: flex;
  flex-direction: column;
}

.gradient-bg-free-training {
  position: absolute;
  width: 100%;
  height: 50%;
  top: 0;
  left: 0;
  background: radial-gradient(circle at 50% 0%, rgba(0, 150, 63, 0.25), transparent 70%);
  animation: aurora-glow 1.5s 0.5s forwards;
  pointer-events: none;
  opacity: 0;
}

.setup-content {
  flex-grow: 1;
  padding: 0 24px;
}

.setup-title {
  font-size: 2.8rem;
  font-weight: 800;
  line-height: 1.2;
  margin-bottom: 8px;
  color: white;
}

.setup-subtitle {
  font-size: 1.1rem;
  color: #a0a0a0;
  margin-bottom: 2rem;
}

.glass-textfield.v-text-field.v-text-field--solo .v-input__control .v-input__slot {
  border: 1px solid rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  box-shadow: none !important;
  border-radius: 16px !important;
}

.vis-item-card {
  border-radius: 24px !important;
  background-color: rgba(255, 255, 255, 0.05) !important;
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.3s cubic-bezier(0.165, 0.84, 0.44, 1) !important;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  perspective: 1000px;
}

.vis-item-img {
  transition: transform 0.3s ease;
  transform: translateZ(0); /* GPU-Beschleunigung */
}

.vis-item-card:hover .vis-item-img {
  transform: translateZ(20px) rotateY(10deg);
}

.vis-item-card--active {
  border-color: var(--glow-color) !important;
  transform: scale(1.08);
  border-width: 3px;
  box-shadow: 0 0 25px var(--glow-color), 0 0 10px rgba(255, 255, 255, 0.2) inset;
}

.setup-actions {
  padding: 16px 24px 24px; /* Mehr Platz unten */
  background: linear-gradient(to top, rgba(16, 16, 16, 1) 50%, rgba(16, 16, 16, 0));
}

.start-btn-glow {
  box-shadow: 0 0 25px rgba(0, 150, 63, 0.6);
  animation: pulse-glow-primary 2.5s infinite;
}


/* --- ANIMATIONEN --- */

@keyframes dialog-slide-up {
  from { transform: translateY(100%); }
  to { transform: translateY(0); }
}

@keyframes aurora-glow {
  from { opacity: 0;  }
  to { opacity: 1;  }
}

.anim-fade-in-up {
  animation: fade-in-up 0.8s 0.3s cubic-bezier(0.19, 1, 0.22, 1) forwards;
  opacity: 0;
  transform: translateY(30px);
}

.anim-fade-in-up-delay {
  animation: fade-in-up 0.8s 0.5s cubic-bezier(0.19, 1, 0.22, 1) forwards;
  opacity: 0;
  transform: translateY(30px);
}
.anim-fade-in-up-delay-2 {
  animation: fade-in-up 0.8s 0.7s cubic-bezier(0.19, 1, 0.22, 1) forwards;
  opacity: 0;
  transform: translateY(30px);
}


@keyframes fade-in-up {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes pulse-glow-primary {
  0% { box-shadow: 0 0 25px rgba(0, 150, 63, 0.6); }
  50% { box-shadow: 0 0 40px rgba(0, 150, 63, 0.8); }
  100% { box-shadow: 0 0 25px rgba(0, 150, 63, 0.6); }
}
/* NEUE STYLES FÜR DEN AKTIVEN WORKOUT-BANNER */
.active-workout-banner {
    position: relative;
    border-radius: 20px;
    cursor: pointer;
    overflow: hidden;
    color: white;
    box-shadow: 0 10px 30px rgba(0,0,0,0.4);
    transition: transform 0.3s ease;
}
.active-workout-banner:hover {
    transform: scale(1.03);
}

.active-workout-banner .content {
    position: relative;
    z-index: 2;
    display: flex;
    align-items: center;
    padding: 16px;
    background: rgba(30, 30, 30, 0.6);
    backdrop-filter: blur(15px);
    -webkit-backdrop-filter: blur(15px);
}

.glow-border {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 20px;
    box-shadow: 0 0 0 2px var(--v-primary-base);
    animation: pulse-border 2s infinite ease-in-out;
    z-index: 1;
}

.shine-effect {
    position: absolute;
    top: 0;
    left: -150%;
    width: 50%;
    height: 100%;
    background: linear-gradient(to right, rgba(255,255,255,0) 0%, rgba(255,255,255,0.2) 50%, rgba(255,255,255,0) 100%);
    transform: skewX(-25deg);
    animation: shine 4s infinite linear;
    z-index: 3;
}

.avatar-glow {
    box-shadow: 0 0 15px rgba(255,255,255,0.5);
}

.active-info .title {
    font-weight: 700;
    font-size: 1rem;
}

.active-info .status {
    display: flex;
    align-items: center;
    font-size: 0.8rem;
    font-weight: 500;
    color: rgba(255,255,255,0.7);
}

.live-indicator {
    width: 8px;
    height: 8px;
    background-color: #f44336;
    border-radius: 50%;
    margin-left: 8px;
    box-shadow: 0 0 8px #f44336;
    animation: pulse-live 1.5s infinite;
}


.stat-item {
    position:absolute;
    bottom: 12px;
    align-items: center;
    right: 4px;
    font-size: 12px;
}

.chevron {
    color: rgba(255,255,255,0.5);
    transition: transform 0.3s ease;
}
.active-workout-banner:hover .chevron {
    transform: translateX(5px);
}

/* Slide Down Animation */
.slide-down-enter-active, .slide-down-leave-active {
  transition: all 0.5s cubic-bezier(0.25, 0.8, 0.25, 1);
}
.slide-down-enter, .slide-down-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}

/* Keyframe-Animationen */
@keyframes pulse-border {
  0% { box-shadow: 0 0 0 2px var(--v-primary); }
  50% { box-shadow: 0 0 15px 4px var(--v-primary); }
  100% { box-shadow: 0 0 0 2px var(--v-primary); }
}
@keyframes shine {
  100% { left: 150%; }
}
@keyframes pulse-live {
  0% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.4); opacity: 0.7; }
  100% { transform: scale(1); opacity: 1; }
}
.close-btn {
  position: absolute;
  top: 8px;
  right: 8px;
    background-color: rgba(255,255,255,0.1);
    color: rgba(255,255,255,0.7) !important;
}

</style>